import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import TrustIndicators from './components/TrustIndicators';

import { TListingClient } from 'types/TListing';

type TAutomotiveTrustIndicatorsApp = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
};

const AutomotiveTrustIndicatorsApp = ({ appState, environment }: TAutomotiveTrustIndicatorsApp) => {
  const {
    listing: { automotiveTrustIndicators },
  } = appState;

  if (!automotiveTrustIndicators) {
    return;
  }

  return (
    <EnvironmentProvider value={environment}>
      <TrustIndicators trustIndicators={automotiveTrustIndicators} />
    </EnvironmentProvider>
  );
};

export default AutomotiveTrustIndicatorsApp;
